export const propiedadesUsuario = {
  modificar: false,
  eliminar: false,
  exportaDocumentos: false,
  visarCotizacion: false,
  enviarKardex: false,
  enviarCtes: false,
  anular: false,
  anularCotizacion: false,
  anularOrdenPedido: false,
  anularGuiaRemision: false,
  anularComprobanteVenta: false,
  anularGuiaRecepcion: false,
  usaPeriodofijo: false,
  visarOrdenpedido: false,
  visarRequerimientocompra: false,
  visarOrdencompra: false,
  visarOrdenproduccion: false,
  aprobarOrdenpedido: false,
  visarOrdendevolucion: false,
  codigoVendedor: 0,
  desentregarGuiaRecepcion: false,
};

export const requirements = [
  'Formato : JPG',
  'Peso máximo : 1Mb',
  'Ancho recomendado : 600px',
  'Largo recomendado : 400px',
];
export const requerimentsClave = [
  'La contraseña debe tener al menos 8 caracteres',
  'Debe contener al menos 1 letra minúscula',
  'Debe contener al menos 1 letra mayúscula',
  'Debe contener al menos 1 número',
  'Debe contener al menos 1 carácter especial',
  'Las contraseñas deben coincidir',
];
export const tipoFirmaList = [
  { codigo: 1, descri: 'Cotizaciones y Orden de Pedido' },
  { codigo: 2, descri: 'Certificados de Calidad' },
];


export const themesList = [
  { codigo: 'DEFAULT', descri: 'Default', className: 'light' },
  { codigo: 'DARK', descri: 'Dark', className: 'dark' },
  { codigo: 'SKYBLUE', descri: 'Sky Blue', className: 'sky-blue' },
  { codigo: 'AMETHYST', descri: 'Amethyst', className: 'purple' },
  { codigo: 'MATRIX', descri: 'Matrix', className: 'high-contrast-green' },
];

export const themeMap: Record<string, string> =
  themesList.reduce((acc, theme) => {
    acc[theme.codigo] = theme.className;
    return acc;
  }, {} as Record<string, string>);
